export class Company {
  constructor(
    public id: string = '',
    public name: string = '',
    public website: string = '',
    public aboutUs: string = '',
    public companyFile?: File
  ) {}
}
export class File {
  constructor(
    public createdDate: string = '',
    public createdBy: string,
    public id: string,
    public companyId: string,
    public file: {
      createdDate: string;
      createdBy: string;
      id: string;
      name: string;
      contentType: string;
      fileType: string;
    }
  ) {}
}
